import React from 'react';

function LegalNotice() {
  // --- STYLE OBJECTS FOR CLEANLINESS AND REUSABILITY ---

  // Style for the parent column to add vertical spacing between cards
  const columnStyle = {
    marginBottom: '30px' // Adds space below each card container
  };

  // Style for the card itself
  const cardStyle = {
    backgroundColor: '#ffffff',
    padding: '30px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.07)',
    border: '1px solid #e9ecef',
    height: '100%',
    transition: 'transform 0.2s ease-in-out' 
  };

  return (
    <div className='h-auto'>
      <section className="inner-banner-wrap ">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container">
            <div className="inner-banner-content">
              <h1 className="inner-title">Legal Notice</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Section */}
      <div className="about-page-section">
        <div className="about-inner-page">
          <div className="container">
            {/* Company Info Header */}
            <div className="about-head-wrap" style={{ marginBottom: '50px' }}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-head">
                    <div className="title-divider" />
                    <h2 className="section-title">
                      Code Pulse Infotech <span className="primary-color">Legal Notice</span>
                    </h2>
                    <div className="company-info" style={{ marginTop: '20px', lineHeight: '1.8' }}>
                      <p><strong>Company Name:</strong> Code Pulse Infotech</p>
                      <p><strong>Website:</strong> www.codepulseinfotech.com</p>
                      <p><strong>Email:</strong> contact@codepulseinfotech.com</p>
                      <p><strong>Phone:</strong> +1 (XXX) XXX-XXXX</p>
                      <p><strong>Registered Address:</strong> [Your Company Address Here]</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Legal Points using process-count structure for consistency */}
            <div className="process-count-wrap">
              <div className="row mb-3 pb-5">
                {/* Card 1 */}
                <div className="col-md-6" style={columnStyle}>
                  <div className="process-count-item" style={cardStyle}>
                    <span className="process-number">01.</span>
                    <div className="process-content">
                      <h4>Ownership of Website and Content</h4>
                      <p>
                        All content on this website, including but not limited to text, graphics, images, logos, icons, software, and code, is the exclusive property of Code Pulse Infotech, unless otherwise stated. Any reproduction, distribution, modification, or unauthorized use of this content is strictly prohibited without prior written consent from Code Pulse Infotech.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Card 2 */}
                <div className="col-md-6" style={columnStyle}>
                  <div className="process-count-item" style={cardStyle}>
                    <span className="process-number">02.</span>
                    <div className="process-content">
                      <h4>Use of Website</h4>
                      <p>
                        By accessing or using this website, you agree to comply with all applicable laws and regulations. You agree not to engage in unlawful activities, attempt to gain unauthorized access, or copy, modify, or distribute any website content without authorization.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Card 3 */}
                <div className="col-md-6" style={columnStyle}>
                  <div className="process-count-item" style={cardStyle}>
                    <span className="process-number">03.</span>
                    <div className="process-content">
                      <h4>Intellectual Property Rights</h4>
                      <p>
                        All trademarks, service marks, trade names, logos, and software displayed on this site are owned by Code Pulse Infotech or its respective licensors. Use of these without prior written permission is strictly prohibited.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Card 4 */}
                <div className="col-md-6" style={columnStyle}>
                  <div className="process-count-item" style={cardStyle}>
                    <span className="process-number">04.</span>
                    <div className="process-content">
                      <h4>Disclaimer of Warranties</h4>
                      <p>
                        This website and all its content are provided “as is” without warranties of any kind, whether express or implied. While Code Pulse Infotech strives to ensure the accuracy of the information, we do not guarantee that the content is error-free, complete, or up to date.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Card 5 */}
                {/* <div className="col-md-6" style={columnStyle}>
                  <div className="process-count-item" style={cardStyle}>
                    <span className="process-number">05.</span>
                    <div className="process-content">
                      <h4>Limitation of Liability</h4>
                      <p>
                        In no event shall Code Pulse Infotech be held liable for any damages arising from the use or inability to use this website, including but not limited to direct, indirect, incidental, or consequential damages.
                      </p>
                    </div>
                  </div>
                </div> */}
                {/* Card 6 */}
                {/* <div className="col-md-6" style={columnStyle}>
                  <div className="process-count-item" style={cardStyle}>
                    <span className="process-number">06.</span>
                    <div className="process-content">
                      <h4>Third-Party Links</h4>
                      <p>
                        This website may contain links to external websites for convenience. Code Pulse Infotech does not endorse, control, or assume responsibility for the content, security, or practices of third-party websites.
                      </p>
                    </div>
                  </div>
                </div> */}
                {/* Card 7 */}
                <div className="col-md-6" style={columnStyle}>
                  <div className="process-count-item" style={cardStyle}>
                    <span className="process-number">05.</span>
                    <div className="process-content">
                      <h4>Privacy</h4>
                      <p>
                        Your use of this site is also governed by our Privacy Policy. Please review it to understand how we collect, process, and protect your personal data.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Card 8 */}
                <div className="col-md-6" style={columnStyle}>
                  <div className="process-count-item" style={cardStyle}>
                    <span className="process-number">06.</span>
                    <div className="process-content">
                      <h4>Governing Law and Jurisdiction</h4>
                      <p>
                        These terms shall be governed by and construed under the laws of [Your Country/State]. Any disputes shall fall under the exclusive jurisdiction of the courts located in [Your Location].
                      </p>
                    </div>
                  </div>
                </div>
                {/* Card 9 */}
                <div className="col-md-6" style={columnStyle}>
                  <div className="process-count-item" style={cardStyle}>
                    <span className="process-number">07.</span>
                    <div className="process-content">
                      <h4>Modifications</h4>
                      <p>
                        Code Pulse Infotech reserves the right to modify, update, or revise this Legal Notice at any time without prior notice. Any changes will be posted on this page with the updated effective date.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Card 10 */}
                <div className="col-md-6 " style={columnStyle}>
                  <div className="process-count-item" style={cardStyle}>
                    <span className="process-number">08.</span>
                    <div className="process-content">
                      <h4>Contact Information</h4>
                      <p>
                        For any legal concerns or inquiries, please contact:
                      </p>
                      <p>📧 Email: legal@codepulseinfotech.com</p>
                      <p>📞 Phone: +1 (XXX) XXX-XXXX</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LegalNotice;
